import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/big-shoulders-display/700.css';
import '@fontsource/big-shoulders-display/900.css';
import '@fontsource/barlow/400.css';
import '@fontsource/barlow/500.css';
import '@fontsource/barlow/600.css';
import '@fontsource/barlow/700.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource/mukta/500.css';
import '@fontsource/mukta/600.css';
import '@fontsource/mukta/700.css';
import '@fontsource/mukta/800.css';
import './styles.css';
import './v3.css';
import './control.css';
import './moment-studio.css';
import './director.css';
import './personal.css';
import './live.css';
import './scene.css';
import './first.css';
import './show.css';
import './showrunner.css';
import { App } from './App';
import { ClientContext, loadClient } from './client';

const root = createRoot(document.getElementById('root')!);
loadClient().then((client) =>
  root.render(
    <StrictMode>
      <ClientContext.Provider value={client}>
        <App />
      </ClientContext.Provider>
    </StrictMode>,
  ),
);
